import { ApplicationStep, StepbystepApplicationStep } from 'embed/constants'
import { Product } from 'even-ts-static'

type Step = {
  [S in ApplicationStep]?: string
}

type AssistantStepCopyByProduct = { [P in Product]?: Step }

export const assistantStepByStepText: AssistantStepCopyByProduct = {
  [Product.Loan]: {
    [StepbystepApplicationStep.LoanAmount]: `Most people borrow between $2k - $25k. I’ll have a harder time finding offers for more than half your annual income.`,
    [StepbystepApplicationStep.LoanPurpose]: `Personal loans can be used for a multitude of purposes, but your loan purpose can impact your rate.`,
    [StepbystepApplicationStep.CreditRating]: `Your credit rating may impact both your chances of getting approved for a loan and your rate on that loan.`,
    [StepbystepApplicationStep.Email]: `We'll use this information to send you update about the status of your offers and more.`,
    [StepbystepApplicationStep.DateOfBirth]: `I'll need this to match you with offers. Plus, you may qualify for a better rate depending on your age.`,
    [StepbystepApplicationStep.Name]: `I'll need this to match you with offers. Plus, you may qualify for a better rate depending on your age.`,
    [StepbystepApplicationStep.PropertyStatus]: `Just a few questions left!`,
    [StepbystepApplicationStep.EducationLevel]: `You're here, being proactive about your finances and looking at all the options. And that's great!`,
    [StepbystepApplicationStep.Address]: `I'll look to see if your address matches what we get from the credit reporting agency.`,
    [StepbystepApplicationStep.Phone]: `We'll use this information to send you update about the status of your offers and more.`,
    [StepbystepApplicationStep.EmploymentStatus]: `Our partners want us to ask you about your employment status.`,
    [StepbystepApplicationStep.AnnualIncome]: `Keep in mind, I don't often have luck finding loan offers that are more than half your annual income.`,
    [StepbystepApplicationStep.PayFrequency]: `Wouldn't it be great if every day were payday?`,
    [StepbystepApplicationStep.SocialSecurity]: `You're one step away from viewing pre-approved and pre-qualified personal loan offers from our partners!`,
  },
}
